import { GlobalPropertyKeys } from '../types';
import type { GlobalValues, Prime100QuotePageState } from '../types';

import type { EligibleCoverageValuesResponse } from '../api/types';

type GlobalProperties = Pick<
  EligibleCoverageValuesResponse,
  keyof typeof GlobalPropertyKeys
>;

export const formatGlobalValues = (
  coverageValues: Prime100QuotePageState['coverageValues'] | undefined
) => {
  const globalProperties: (keyof GlobalProperties)[] =
    Object.values(GlobalPropertyKeys);

  const globalValues: Partial<GlobalValues> = {};

  globalProperties.forEach((key) => {
    const targetProperty = coverageValues?.[key];

    /* If this happens, BE is returning unexpected results. Its best to fail fast */
    if (!targetProperty) {
      throw new Error(
        'Unable to find coverage value property in formatGlobalValues'
      );
    }

    globalValues[key] = {
      value: targetProperty.default,
      options: targetProperty.values,
    };
  });

  return globalValues as GlobalValues;
};

export default <T extends Prime100QuotePageState>(data: T) => {
  const globalValues = formatGlobalValues(data.coverageValues);

  return {
    ...data,
    globalValues,
  };
};
